import { classNames } from "../../helpers/classNames";
import Image from "./Image";
import { useState } from "react";

const Indentification = ({
  image,
  initial,
  className,
  divStyle,
  initialClass,
  initialStyle,
  defaultClass,
  defaultStyle,
  fill = true,
  alt,
  size = "md",
  type = "square",
}) => {
  const [imgFailed, setImgFailed] = useState(false);

  const imageSize = {
    xs: "w-6 h-6",
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
    xl2:"w-20 h-20",
    xl3:"w-26 h-26",
    max: "w-full h-full",
  };

  const src = image;
  const ext = src?.split(".").pop()?.toLowerCase();
  const isVideo = ["mp4", "webm"].includes(ext);

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const showImage = image && isValidUrl(image) && !imgFailed;

  return (
    <div
      className={classNames(
        "overflow-hidden bg-text-secondary/15 flex items-center justify-center flex-shrink-0",
        imageSize[size],
        initial ? "text-sm" : "",
        type === "circle"
          ? "rounded-full"
          : type === "square"
            ? "rounded-lg"
            : "",
        className,
      )}
      style={divStyle}
    >
      {showImage ? (
        isVideo ? (
          <video
            className={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain",
            )}
            src={image}
            alt={alt || initial || image}
            controls
            onError={() => setImgFailed(true)}
          />
        ) : (
          <Image
            src={image}
            alt={alt || initial || image}
            classes={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain",
            )}
            onError={() => setImgFailed(true)}
          />
        )
      ) : initial ? (
        <div
          className={classNames(
            `w-full h-full flex items-center justify-center font-normal uppercase text-sm ${initialStyle?.background ? "" : "bg-denim"
            } text-white !leading-none`,
            initialClass,
          )}
          style={initialStyle}
        >
          <span className="-mt-[2px]">{initial}</span>
        </div>
      ) : (
        <div
          className={classNames(
            "w-full h-full flex items-center justify-center bg-white text-gray-500",
            defaultClass,
          )}
          style={defaultStyle}
        >
          <i className="fa-light fa-fw fa-user"></i>
        </div>
      )}
    </div>
  );
};

export default Indentification;
